import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Label and value rows for a record's fields: the issue properties sidebar, a work
 * order's facts. Labels sit in a fixed column so the values line up down the list.
 */
export function PropertyList({ className, children }: { className?: string; children: ReactNode }) {
  return <dl className={cn("grid gap-y-0.5", className)}>{children}</dl>;
}

export function PropertyRow({
  label,
  icon: Icon,
  children,
  className,
}: {
  label: string;
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("grid min-h-7.5 grid-cols-[6.5rem_minmax(0,1fr)] items-center gap-x-3", className)}>
      <dt className="flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground">
        {Icon && <Icon className="size-3.5 shrink-0 text-muted-foreground/80" />}
        <span className="truncate">{label}</span>
      </dt>
      <dd className="min-w-0 text-sm">{children}</dd>
    </div>
  );
}
